import { GraphQlRequestService } from '../../../api/graphql-request-service';
import { Hasher } from '../hasher';
import { HasDependencies, hashString, RoleId } from '../types';
import { handleGQLErrors } from '../utils';
import { NotificationService } from './service';

export class GraphQlNotificationService
  implements NotificationService, HasDependencies
{
  constructor(
    readonly graphQlRequestService: GraphQlRequestService,
    readonly domain: string,
    readonly simulatedRole: RoleId | null
  ) {}

  public getDeps = () => [
    hashString([
      this.domain,
      Hasher.hash(this.simulatedRole),
      ...this.graphQlRequestService.getDeps(),
    ]),
  ];

  public sendDataProcessingTestMicrosoftTeamsNotification: (
    webhookUrl: string
  ) => Promise<void> = async (webhookUrl: string) => {
    await handleGQLErrors(
      this.graphQlRequestService.graphQlSdk.sendDataProcessingTestMicrosoftTeamsNotificationArgs(
        {
          domain: this.domain,
          webhookUrl: webhookUrl,
          simulateRole: this.simulatedRole,
        }
      )
    );
  };
}
